import { UseMutationResult } from "@tanstack/react-query";
import { UseFormReturn } from "react-hook-form";

import { FormHelperText, Stack } from "@mui/material";

import TextField from "@app/analytics/components/TextField";

import UpdateButtons from "../../components/UpdateButtons";

const ProfileForm = ({
  onSubmit,
  form,
  onCancel,
  status,
}: {
  onSubmit: () => void;
  form: UseFormReturn;
  onCancel: () => void;
  status: UseMutationResult<
    any,
    unknown,
    { firstName: string; lastName: string },
    unknown
  >;
}) => {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <Stack spacing={2}>
      <FormHelperText sx={{ color: "error.main" }}>
        Required Field *
      </FormHelperText>
      <Stack direction="row" spacing={1}>
        <TextField
          label="First Name"
          required
          error={Boolean(errors.firstName)}
          helperText={
            typeof errors.firstName?.message === "string"
              ? errors.firstName.message
              : null
          }
          InputProps={{
            ...register("firstName"),
          }}
        />
        <TextField
          label="Last Name"
          required
          error={Boolean(errors.lastName)}
          helperText={
            typeof errors.lastName?.message === "string"
              ? errors.lastName.message
              : null
          }
          InputProps={{
            ...register("lastName"),
          }}
        />
      </Stack>
      <UpdateButtons
        disabled={status.isSuccess}
        loading={status.isPending}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    </Stack>
  );
};

export default ProfileForm;
